/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

const styles = {
  root: css`
    padding: var(--cds-spacing-150);
    border-top: 1px solid rgb(0 0 0 / 12%);
    border-bottom: 1px solid rgb(0 0 0 / 12%);
  `,
};

const MessageCard = ({ children }: { children: React.ReactNode }) => (
  <div className="rc-MessageCard" css={styles.root} data-testid="message-card">
    {children}
  </div>
);

export default MessageCard;
